<script>
import { ImageGrid } from '@/ui-kit';
import PortraitCardOverlay from './PortraitCardOverlay.vue';

export default {
  components: {
    ImageGrid,
    PortraitCardOverlay,
  },
  emits: [
    'itemClick',
    'itemLoad',
    'switchSlide',
    'toggleSelection',
    'generateMore',
    'tryAgain',
    'countDecrement',
    'countIncrement',
  ],
  props: {
    items: {
      type: Array,
      required: true,
    },
    layout: {
      type: Object,
      required: true,
    },
    sizing: {
      type: String,
      required: true,
    },
    cellWidth: {
      type: [Number, String],
      required: true,
    },
    cellHeight: {
      type: [Number, String],
      required: true,
    },
    cellAspectRatio: {
      type: Number,
      required: true,
    },
    fit: {
      type: String,
      required: true,
    },
    gap: {
      type: String,
      required: true,
    },
    cellRadius: {
      type: String,
      required: true,
    },
    arrowScale: {
      type: Number,
      required: true,
    },
    selectedUuids: {
      type: Array,
      required: true,
    },
    showGenerateMore: {
      type: Boolean,
      required: true,
    },
    generateMoreDisabled: {
      type: Boolean,
      required: true,
    },
    getSelectedPortraitCount: {
      type: Function,
      required: true,
    },
  },
  methods: {
    canScroll() {
      return this.$refs.gallery?.canScroll?.() ?? false;
    },
    isItemVisible(uuid) {
      return this.$refs.gallery?.isItemVisible?.(uuid) ?? false;
    },
    scrollToItem(uuid) {
      this.$refs.gallery?.scrollToItem?.(uuid);
    },
  },
};
</script>

<template>
  <div
    class="PortraitImageGrid Portraits__gallery"
    data-testid="portrait-image-grid"
  >
    <ImageGrid
      ref="gallery"
      :items="items"
      :layout="layout"
      :sizing="sizing"
      :cell-width="cellWidth"
      :cell-height="cellHeight"
      :cell-aspect-ratio="cellAspectRatio"
      :fit="fit"
      :gap="gap"
      :cell-radius="cellRadius"
      :arrow-scale="arrowScale"
      :selected-uuids="selectedUuids"
      state-class-prefix="Portraits"
      :show-generate-more="showGenerateMore"
      :generate-more-disabled="generateMoreDisabled"
      @item-click="(portrait, index, event) => $emit('itemClick', portrait, index, event)"
      @item-load="(portrait, index, event) => $emit('itemLoad', portrait, index, event)"
      @toggle-selection="
        (event, portrait, isSelected) =>
          $emit('toggleSelection', event, portrait, isSelected)
      "
      @visible-items-change="(...args) => $emit('switchSlide', ...args)"
      @generate-more="$emit('generateMore')"
    >
      <template #default="{ item: portrait }">
        <PortraitCardOverlay
          class-prefix="PortraitImageGrid"
          :portrait="portrait"
          :selected="selectedUuids.includes(portrait.uuid)"
          :selected-count="getSelectedPortraitCount(portrait)"
          @try-again="$emit('tryAgain', portrait)"
          @count-decrement="
            (event) => $emit('countDecrement', event, portrait)
          "
          @count-increment="
            (event) => $emit('countIncrement', event, portrait)
          "
        />
      </template>
    </ImageGrid>
  </div>
</template>

<style scoped>
.PortraitImageGrid {
  flex: var(--portrait-image-grid-flex, 0 1 auto);
  width: var(--portrait-image-grid-width, min(100%, 96rem));
  height: var(--portrait-image-grid-height, 42rem);
  min-width: 0;
  min-height: 0;
}
</style>
